import { useState, useEffect, useRef } from 'react';

const useSessionTimeout = (
  isLoggedIn,
  initialTimeout = 600,
  onSessionExpire = () => {}
) => {
  const [sessionExpire, setSessionExpire] = useState(false);
  const timeoutRef = useRef(initialTimeout);
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (!isLoggedIn) return;
    timeoutRef.current = initialTimeout;
    localStorage.setItem('lastActivity', Date.now().toString());
    localStorage.setItem('sessionExpired', JSON.stringify(false));
    startTimer();
  };

  const startTimer = () => {
    if (!isLoggedIn || timerRef.current) return;
    stopTimer(); // Clear any previous timer before starting a new one

    timerRef.current = setInterval(() => {
      const lastActivity = parseInt(
        localStorage.getItem('lastActivity') || Date.now().toString(),
        10
      );
      const timeSinceLastActivity = Math.floor(
        (Date.now() - lastActivity) / 1000
      );

      timeoutRef.current = initialTimeout - timeSinceLastActivity;

      if (timeoutRef.current <= 0) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        setSessionExpire(true);
        localStorage.setItem('sessionExpired', JSON.stringify(true));
        onSessionExpire();
      }
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      // **Fix:** Reset session state when logging in
      setSessionExpire(false);
      localStorage.setItem('sessionExpired', JSON.stringify(false));
      resetTimer();

      const handleUserActivity = () => resetTimer();

      document.addEventListener('keydown', handleUserActivity);
      document.addEventListener('mousemove', handleUserActivity);
      document.addEventListener('visibilitychange', resetTimer);

      return () => {
        document.removeEventListener('keydown', handleUserActivity);
        document.removeEventListener('mousemove', handleUserActivity);
        document.removeEventListener('visibilitychange', resetTimer);
        stopTimer();
      };
    } else {
      stopTimer();
      setSessionExpire(false);
      localStorage.setItem('sessionExpired', JSON.stringify(false)); // Reset on logout
    }
  }, [isLoggedIn]);

  return { sessionExpire };
};

export default useSessionTimeout;
